// extracted by mini-css-extract-plugin
export default {"topLeft":"Annotation_topLeft__wA-5b","circle":"Annotation_circle__3xzG-","text":"Annotation_text__zvW1E","line":"Annotation_line__XQpRq"};